import { type GroupId, type IBrandUnderGroupPayload } from "@/api/admin/groups";
import { apiClient } from "@/api/client";
import { type GroupInformationFormType } from "@/components/units/GroupInformationForm";
import { API_ENDPOINTS } from "@/config/app";
import type { PaginatedResponse, PaginationParams } from "@/types/api";
import { buildUrl } from "@/utils/buildUrl";

export const groupsApi = {
  async postGroup(groupData: GroupInformationFormType) {
    const response = await apiClient.post<GroupInformationFormType>(
      `${API_ENDPOINTS.ADMIN}/groups`,
      groupData
    );
    return response;
  },

  async getGroups(
    params?: PaginationParams & { country?: string }
  ): Promise<PaginatedResponse<GroupInformationFormType>> {
    const url = buildUrl(API_ENDPOINTS.ADMIN, "/groups", params);

    const response =
      await apiClient.get<PaginatedResponse<GroupInformationFormType>>(url);
    return response;
  },

  async getGroupById(groupId: GroupId): Promise<IBrandUnderGroupPayload> {
    const response = await apiClient.get<IBrandUnderGroupPayload>(
      `${API_ENDPOINTS.ADMIN}/groups/${groupId}`
    );
    return response;
  },

  async deleteGroup(groupId: GroupId) {
    const response = await apiClient.delete(
      `${API_ENDPOINTS.ADMIN}/groups/${groupId}`
    );
    return response;
  },

  async patchGroup(
    groupId: GroupId,
    groupData: Partial<GroupInformationFormType>
  ) {
    const response = await apiClient.patch<GroupInformationFormType>(
      `${API_ENDPOINTS.ADMIN}/groups/${groupId}`,
      groupData
    );
    return response;
  },
};
